import { Moment } from '@chipinside/frontend'
import { MarkdownView } from '@chipinside/markdown'
import { Translate } from '@chipinside/translate'
import { Box, Button, DialogContent, Stack, Typography } from '@mui/material'

// @ts-ignore
import ImgVelmaRelease from '#/assets/vic/velma_release.png'
// @ts-ignore
import ImgVickyRelease from '#/assets/vic/vicky_release.png'
import { useFarmAssistant } from '#/store/ducks/farm'

export function ReleaseNoteContent({ data, handleOnClick }) {
  const farmAssistant = useFarmAssistant()

  return (
    <Box>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'grey.100',
          display: 'flex',
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            mx: 3,
            my: 1.5,
          }}
        >
          <img
            alt="VIC"
            src={farmAssistant === 'vicky' ? ImgVickyRelease : ImgVelmaRelease}
            height={60}
          />
        </Box>
        <Stack>
          <Typography variant="h6" sx={{ color: 'grey.800' }}>
            {Translate({ messageKey: 'your_software_was_updated' })}
          </Typography>
          <Typography sx={{ color: 'grey.800' }}>
            {Translate({
              messageKey: ['version_updated_at', Moment(data?.release_date).format('L')],
              translate: [true, false],
            })}
          </Typography>
        </Stack>
      </Box>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 4 }}>
        <Typography variant="h6">{data?.release_title}</Typography>
        <MarkdownView>{data?.release_note}</MarkdownView>
        <Stack direction="row" sx={{ gap: 2, justifyContent: 'flex-end', mt: 1 }}>
          <Button variant="outlined" onClick={() => handleOnClick('read-later')}>
            {Translate({ messageKey: 'read_later' })}
          </Button>
          <Button variant="contained" color="primary" onClick={() => handleOnClick()}>
            {Translate({ messageKey: 'i_got_it' })}
          </Button>
        </Stack>
      </DialogContent>
    </Box>
  )
}
